import { Tooltip } from "antd";
import React, { useContext } from "react";
import { IoSaveOutline } from "react-icons/io5";
import FetchContext from "../../../../contexts/fetch";
import useConfirmation from "../../../../hooks/useConfirmation";
import UseOnSaveFlow from "../UseOnSaveFlow";
import styles from "../controls.module.css";

const Save = () => {
  const [fetchState] = useContext(FetchContext);

  const { onSave } = UseOnSaveFlow();

  /* const onSave = useCallback(() => {
    if (flowState.rfInstance) {
      let flow = flowState.rfInstance.toObject();
      const nodes = flow.nodes.map((node) => {
        const { handleBounds, selected, ...rest } = node;
        return {
          ...rest,
        };
      });
      const edges = flow.edges.map((edge) => {
        const { selected, animated, ...rest } = edge;
        return {
          ...rest,
        };
      });

      const viewport = flow.viewport;
      const { _id, rfInstance, ...flowData } = flowState;

      if (!flowData.app) {
        flowData.app = userState.currentApp;
      }
      if (!flowData.brand) {
        flowData.brand = userState.currentBrand;
      }
      if (!flowData.name) {
        flowData.name = userState.currentFlowName;
      }
      if (!flowData.version) {
        flowData.version = userState.currentVersion;
      }

      fetchDispatcher({
        type: "fetch-save-flow",
        brand: userState.currentBrand,
        flowId: _id,
        app: userState.currentApp,
        flow: {
          ...flowData,
          nodes,
          edges,
          viewport,
        },
        onSuccess: (msg, flowId) => {
          notificationDispatcher({
            type: "notify",
            notification: {
              id: uuid(),
              type: "success",
              message: msg,
              duration: 3000,
            },
          });
          flowDispatcher({
            type: "update-flow-data",
            key: "_id",
            value: flowId,
          });
          fetchDispatcher({
            type: "fetch-flow-list",
            app: userState.currentApp,
          });
        },
        onError: (msg) => {
          notificationDispatcher({
            type: "notify",
            notification: {
              id: uuid(),
              type: "failure",
              message: msg,
              duration: 3000,
            },
          });
        },
      });
    }
  }, [flowState.rfInstance, notificationDispatcher, flowState]); */

  const saveWithConfirmation = useConfirmation(
    {
      title: "Confirmer la sauvegarde",
      message: "La sauvegarde écrasera l'ancienne version. Continuer ?",
      onOk: onSave,
    },
    fetchState.loadingSaveApi
  );

  const handleSaveButtonClick = function () {
    saveWithConfirmation();
  };

  return (
    <div className={styles.button_container} onClick={handleSaveButtonClick}>
      <Tooltip placement="bottom" title={"Save"}>
        <span className={styles.icon_container}>
          <IoSaveOutline className={styles.save_button} />
        </span>
      </Tooltip>
    </div>
  );
};

export default Save;
